export enum GivePointMethodTypeEnum {
  SERIAL = 'serial',
  RECEIPT_DECLARATION = 'receipt_declaration',
  RECEIPT_APPROVAL = 'receipt_approval',
  JAN_CODE = 'jan_code',
}
